<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-container-single element-non-bodymatter element-type-dedication element-with-heading" epub:type="dedication" id="dedication">
<div class="heading heading-with-title heading-without-image" id="dedication-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Dedication</h1>
</div>
</div>
</div>
</div>
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">Thanks to:</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Maud Ransom</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Annie Marcoe</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">LaVerne Ransom</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Who taught me to read.</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Ms. Joanne Baird</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Who taught me to type.</p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?c37a54dc